import { CollectionPageType } from "@/app/navigation/collection/collection-page-type"
import type { CollectionId } from "@anaconda/core/nft-collection/types"
import { CollectionNavigationViewReatom } from "./view.reatom"

const ALL_ROUTES = [
  CollectionPageType.ITEMS,
  CollectionPageType.MY_ITEMS,
  CollectionPageType.OFFERS,
  CollectionPageType.ACTIVITY,
]

interface Props {
  collectionId: CollectionId
}

export function CollectionNavigationReatom({ collectionId }: Props) {
  return (
    <CollectionNavigationViewReatom
      routes={ALL_ROUTES}
      collectionId={collectionId}
    />
  )
}
